
// Forcer un Logout si une API retourne un status 401
export const logout = (path) => {
    localStorage.removeItem('user');
    window.location = path;
};
